import { render, staticRenderFns } from "./BlockEditComponent.vue?vue&type=template&id=0b1187dc"
import script from "./BlockEditComponent.vue?vue&type=script&lang=js"
export * from "./BlockEditComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports